import { hintNames } from './clientHintsUtils';
/** @import {ClientHintsState} from './types.js' */

/** @param {{ onResolve: () => void }} callbacks */
export function ClientHintsProvider(callbacks) {
  let state = /** @type {ClientHintsState} */ ({ state: 'loading' });

  if (!navigator.userAgentData?.getHighEntropyValues) {
    state = { state: 'unavailable' };
  } else {
    navigator.userAgentData
      .getHighEntropyValues(hintNames)
      .then((data) => {
        state = { state: 'available', hints: data };
        callbacks.onResolve();
      })
      .catch(() => {
        state = { state: 'unavailable' };
        callbacks.onResolve();
      });
  }

  return {
    getState: () => state,
  };
}
